import { useDispatch } from 'react-redux';
import { useCallback, useRef } from 'react';
import { useChangePlayerFavorites } from 'js/hooks/socket/hooks';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { IChangePlayerFavoritesResponseData } from 'js/hooks/socket/hooks/useChangePlayerFavorites/types';

import * as actions from '../store/actions';

export const useToggleFavoriteGame = () => {
    const dispatch = useDispatch();
    const isInProgress = useRef(false);
    const changeFavoriteGames = useChangePlayerFavorites();

    return useCallback(async ({ gameCode, isFavorite, container, feedName }: {
        gameCode: string;
        isFavorite: boolean;
        feedName?: string;
        container?: string;
    }): Promise<IChangePlayerFavoritesResponseData> => {
        let response: IChangePlayerFavoritesResponseData;

        if (isInProgress.current) {
            return {
                status: 'pending'
            };
        }

        publicEventsAPIService.trigger('favorite-game-toggle', {
            container,
            gameCode,
            gameFeed: feedName,
            isFavorite
        });

        isInProgress.current = true;

        try {
            response = await changeFavoriteGames({ gameTypes: [gameCode], requestType: isFavorite ? 'add' : 'remove' });
        } finally {
            isInProgress.current = false;
        }

        dispatch(actions.toggleFavoriteGame({ gameCodes: [gameCode], isFavorite }));

        return response;
    }, [changeFavoriteGames, dispatch]);
};
